<template>
  <main v-if="loadover">
    <div>
      <p>
        {{ pageCate.cate.summary }}
      </p>
      <h1>相关文献</h1>
      <ul>
        <li
          v-for="item in timeArr"
          :key="item"
          :style="{
            'background-image': `url(${year == item ? select : noselect})`,
            color: year == item ? '#1680D9' : '#999',
          }"
          @click="getList(info.cate.id, { year: item })"
        >
          {{ item }}
        </li>
      </ul>
      <!-- <h1>【{{ info.cate.cate_name }}】</h1> -->
      <!-- <h1>【发表文献】</h1>{{info}} -->
      <!-- <router-link
        class="article"
        :to="item.attachment"
        v-for="item in info.list"
        :key="item.id"
      > -->
      <div
        class="article"
        to="http://baidu.com"
        v-for="item in info.list"
        :key="item.id"
      >
        <p>{{ item.title }}</p>
        <p>{{ item.summary }}</p>
        <div>
          <a :href="item.attachment" target="_blank" class="a">在线预览</a>
          <img src="../assets/image/pdf.png" alt="" />
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "scientific",
  data() {
    return {
      loadover: false,
      select: require("../assets/image/rili.png"),
      noselect: require("../assets/image/rilih.png"),
      year: "",
      timeArr: [],
      // cate: {},
      // params: {
      //   year:''
      // },
      info: {},
    };
  },
  computed: mapGetters(["pageCate", "meanCenterObj"]),
  created() {
    this.getCate({
      parent: this.meanCenterObj,
      // _child: this.meanCenterObj._child[0],
    });
    this.getList(this.meanCenterObj._child[0].id, { year: "" });
    this.getTime();
  },
  methods: {
    ...mapActions(["getCate"]),
    // 时间轴
    getTime() {
      let date = new Date();
      let year = date.getFullYear() - 1;
      for (let i = 0; i < 8; i++) {
        this.timeArr.push(year + i);
      }
      // console.log(year, this.timeArr);
    },
    getList(id, params) {
      this.$api.CATE(id, params).then((res) => {
        // this.$public_data.imageURL(res.list).then(() => {
          Object.assign(this.info, res);
          this.year = params.year;
          this.loadover = true;
        // });
      });
    },
  },
};
</script>

<style scoped lang='less'>
main {
  background-image: linear-gradient(to bottom, #eaf7ff, #eaf7ff, #fffdfd);
  > div {
    overflow: hidden;
    margin: 0 auto;
    max-width: 77.7vw;
    > p {
      font-size:  0.93vw;
      line-height: 2;
      margin: 3.1vw 0;
    }
    > p:first-child {
      font-size:1vw;
    }
    > h1 {
      padding-bottom:1vw;
      border-bottom: 1px solid #d7d7d7;
      margin-bottom:1vw;
    }
    > ul,.article
     {
     width: 63.541vw;
      margin: 0 auto;
    }
    > ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 1.875vw;
      font-weight: bold;
      color: #999;
      > li {
        cursor: pointer;
        // margin: 1.67vw;
        // margin-right: 0;
        width: 7.08vw;
        height: 4.218vw;
        line-height: 4.218vw;
        background-image: url("../assets/image/rili.png");
        // background-image: url('../assets/image/rilih.png');//未选中
        background-size: 7.08vw 4.218vw;
        text-align: center;
      }
      + h1 {
        font-size:  0.93vw;
        margin-left: 1.67vw;
      }
    }
    > .article {
      margin: 2.08vw auto;
      // width: 58.3vw;
      min-height: 7.55vw;
      padding: 2.08vw;
      border: 1px solid #d7d7d7;
      display: flex;
      flex-flow: column nowrap;
      //   align-items: center;
      justify-content: space-around;
      p,
      span {
        font-size:  0.93vw;
        cursor: pointer;
      }
      // .a:hover {
      //   text-decoration: underline;
      // }
      > p:first-child {
        margin-bottom: 0.8854vw;
        color: #1680d9;
        font-weight: bold;
        + p {
          font-size: 0.73vw;
          color: #999;
        }
      }
      > div {
        margin-top:1vw;
        width: 5.208vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > p {
          color: #333;
        }
        img {
          width:1vw;
          height: 1.25vw;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/scientific.vue